import React, { Component } from "react";
import { Radio } from "antd";

const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

class ChangeContractType extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div style={{ marginBottom: "16px" }}>
        <RadioGroup
          onChange={this.props.onChange}
          defaultValue={this.props.defaultValue || "settled"}
        >
          <RadioButton value="settled">基础孵化合同</RadioButton>
          {/* <RadioButton value="oregistapp">地址合同</RadioButton> */}
          <RadioButton value="advanced">高级孵化</RadioButton>
          <RadioButton value="icregister">工商注册</RadioButton>
        </RadioGroup>
      </div>
    );
  }
}

export default ChangeContractType;



// WEBPACK FOOTER //
// ./src/components/incubator/contract/comm/ChangeContractType.js